import { createAction, props } from '@ngrx/store'
import { ChangeItemRequest, ChangeItem } from '../../model'

export enum ChangeRequestChangesActionTypes {
  CREATE_CHANGES = '[Change Request] Create Changes',
  MODIFY_CHANGES = '[Change Request] Modify Changes',

  APPLY_CHANGES = '[Change Request] Apply Changes',
  APPLY_CHANGES_SUCCESS = '[Change Request] Apply Changes Success',
  APPLY_CHANGES_FAIL = '[Change Request] Apply Changes Fail',

  REMOVE_CHANGES = '[Change Request] Remove Changes',
  REMOVE_CHANGES_SUCCESS = '[Change Request] Remove Changes Success',
  REMOVE_CHANGES_FAIL = '[Change Request] Remove Changes Fail',
}

const createChanges = createAction(
  ChangeRequestChangesActionTypes.CREATE_CHANGES,
  props<{ scopeId: number; changeRequestId: number; payload: ChangeItemRequest }>()
)
const modifyChanges = createAction(
  ChangeRequestChangesActionTypes.MODIFY_CHANGES,
  props<{ scopeId: number; changeRequestId: number; changeItemId: string; payload: ChangeItemRequest }>()
)

const applyChanges = createAction(
  ChangeRequestChangesActionTypes.APPLY_CHANGES,
  props<{ payload: ChangeItemRequest }>()
)
const applyChangesSuccess = createAction(
  ChangeRequestChangesActionTypes.APPLY_CHANGES_SUCCESS,
  props<{ changeItem: ChangeItem }>()
)
const applyChangesFail = createAction(ChangeRequestChangesActionTypes.APPLY_CHANGES_FAIL, props<{ error: Error }>())

const removeChanges = createAction(ChangeRequestChangesActionTypes.REMOVE_CHANGES, props<{ changeItemUuid: string }>())
const removeChangesSuccess = createAction(
  ChangeRequestChangesActionTypes.REMOVE_CHANGES_SUCCESS,
  props<{ changeItemUuid: string }>()
)
const removeChangesFail = createAction(ChangeRequestChangesActionTypes.REMOVE_CHANGES_FAIL, props<{ error: Error }>())

export const ChangeRequestChangesActions = {
  createChanges,
  modifyChanges,
  applyChanges,
  applyChangesSuccess,
  applyChangesFail,
  removeChanges,
  removeChangesSuccess,
  removeChangesFail,
}
